document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.getElementById('DdsRouletteOverlay');
  if (!overlay) return;

  var closeBtn = document.getElementById('DdsRouletteClose');
  var emailForm = document.getElementById('DdsRouletteEmailForm');
  var disc = document.getElementById('DdsRouletteDisc');
  var submitBtn = document.getElementById('DdsRouletteSubmitBtn');
  var copyBtn = document.getElementById('DdsRouletteCopyBtn');
  var continueBtn = document.getElementById('DdsRouletteContinueBtn');
  var stateForm = document.getElementById('DdsRouletteStateForm');
  var stateSuccess = document.getElementById('DdsRouletteStateSuccess');

  // Configurări din data attributes
  var delayMs = parseInt(overlay.getAttribute('data-delay') || '15', 10) * 1000;
  
  var couponCode = overlay.getAttribute('data-coupon') || 'DDS5';
  var klaviyoCompany = overlay.getAttribute('data-klaviyo-company') || '';
  var klaviyoList = overlay.getAttribute('data-klaviyo-list') || '';

  // Verifică dacă utilizatorul a învârtit deja sau a refuzat definitiv
  var hasSpun = localStorage.getItem('dds_roulette_spun') === 'true';
  var sessionDismissed = sessionStorage.getItem('dds_roulette_dismissed') === 'true';
  var dismissCount = parseInt(localStorage.getItem('dds_roulette_dismiss_count') || '0', 10);
  var closedAt = localStorage.getItem('dds_roulette_closed_at');
  
  // 1. Dacă a învârtit, a refuzat de 3+ ori sau a închis în această sesiune -> blocat
  if (hasSpun || dismissCount >= 3 || sessionDismissed) return;

  // 2. Verificare cooldown progresiv:
  // - 1 refuz anterior -> pauză 7 zile
  // - 2 refuzuri anterioare -> pauză 30 de zile
  // - 3+ refuzuri -> blocat definitiv (tratat mai sus)
  if (closedAt) {
    var elapsed = Date.now() - parseInt(closedAt, 10);
    var cooldownMs = 7 * 24 * 3600 * 1000; // 7 zile (după primul refuz)
    
    if (dismissCount === 2) {
      cooldownMs = 30 * 24 * 3600 * 1000; // 30 zile (după al doilea refuz)
    }

    if (elapsed < cooldownMs) return;
  }

  // Afișare inteligentă (timp cumulat în sesiune + protecție anti-întrerupere comandă/coș/chat)
  var sessionStart = parseInt(sessionStorage.getItem('dds_roulette_session_start') || '0', 10);
  if (!sessionStart) {
    sessionStart = Date.now();
    sessionStorage.setItem('dds_roulette_session_start', sessionStart.toString());
  }
  var remainingMs = Math.max(2500, delayMs - (Date.now() - sessionStart));

  function isUserBusyBuying() {
    if (document.body.classList.contains('cart-drawer-open') || document.body.classList.contains('chatbot-open')) {
      return true;
    }
    var activeEl = document.activeElement;
    if (activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA' || activeEl.tagName === 'SELECT')) {
      return true;
    }
    var qfOpen = document.querySelector('.dds-qf-wrapper.is-open, .dds-quick-form-container.is-open, #dds-quick-order-form[style*="block"]');
    if (qfOpen) return true;
    return false;
  }

  var timer = null;
  function tryShowRoulette() {
    if (localStorage.getItem('dds_roulette_spun') === 'true' || sessionStorage.getItem('dds_roulette_dismissed') === 'true') {
      return;
    }
    if (isUserBusyBuying()) {
      timer = setTimeout(tryShowRoulette, 5000);
      return;
    }
    overlay.classList.add('is-active');
  }

  timer = setTimeout(tryShowRoulette, remainingMs);

  // Închidere + incrementare număr refuzuri
  function closePopup() {
    if (timer) clearTimeout(timer);
    overlay.classList.remove('is-active');
    
    var currentDismissCount = parseInt(localStorage.getItem('dds_roulette_dismiss_count') || '0', 10);
    currentDismissCount += 1;
    
    localStorage.setItem('dds_roulette_dismiss_count', currentDismissCount.toString());
    localStorage.setItem('dds_roulette_closed_at', Date.now().toString());
    sessionStorage.setItem('dds_roulette_dismissed', 'true');
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (continueBtn) continueBtn.addEventListener('click', closePopup);

  // Închidere la click pe fundalul întunecat (outside modal)
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      closePopup();
    }
  });

  // Închidere la apăsarea tastei ESC
  document.addEventListener('keydown', function(e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && overlay.classList.contains('is-active')) {
      closePopup();
    }
  });

  // Trimite email la Klaviyo via Client API
  function subscribeToKlaviyo(email) {
    if (!klaviyoCompany || !klaviyoList) {
      console.warn('Klaviyo: company_id sau list_id lipsesc');
      return;
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Roulette Popup DDS',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: klaviyoList
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCompany, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      if (!res.ok) {
        console.error('Klaviyo subscription failed:', res.status);
      }
    })
    .catch(function(err) {
      console.error('Klaviyo subscription error:', err);
    });
  }

  // Trimite email la theMarketer (dataLayer __sm__set_email pt. Activity Feed + Supabase API pt. Subscribe)
  function subscribeToTheMarketer(email) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: '__sm__set_email',
      email_address: email
    });

    fetch('https://dvojdpygwauvhsyfgyfb.supabase.co/functions/v1/shopify-order-sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'themarketer_subscribe',
        email: email,
        source: 'ruleta'
      })
    }).catch(function(err) {
      console.error('theMarketer roulette subscription error:', err);
    });
  }

  // Submit formular → Klaviyo + theMarketer + învârtire roată
  emailForm.addEventListener('submit', function(e) {
    e.preventDefault();

    var emailInput = document.getElementById('DdsRouletteEmail');
    var errorDiv = document.getElementById('DdsRouletteError');
    if (!emailInput) return;

    var emailVal = emailInput.value.trim();

    // Resetare erori
    emailInput.classList.remove('is-invalid');
    if (errorDiv) {
      errorDiv.style.display = 'none';
      errorDiv.innerText = '';
    }

    // Validare
    if (!emailVal) {
      emailInput.classList.add('is-invalid');
      if (errorDiv) {
        errorDiv.innerText = 'Te rugăm să completezi adresa ta de email.';
        errorDiv.style.display = 'block';
      }
      return;
    }

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailVal)) {
      emailInput.classList.add('is-invalid');
      if (errorDiv) {
        errorDiv.innerText = 'Te rugăm să introduci o adresă de email validă.';
        errorDiv.style.display = 'block';
      }
      return;
    }

    emailInput.disabled = true;
    submitBtn.disabled = true;
    submitBtn.innerText = 'Se trimite...';

    // Trimitem în paralel la Klaviyo + theMarketer
    subscribeToKlaviyo(emailVal);
    subscribeToTheMarketer(emailVal);

    // Învârtire roată — se oprește mereu pe una dintre cele 3 felii de 5% (30°, 150° sau 270°)
    var winningAngles = [240, 120, 360];
    var randomBaseAngle = winningAngles[Math.floor(Math.random() * winningAngles.length)];
    var targetAngle = randomBaseAngle + 1800;
    disc.style.transform = 'rotate(' + targetAngle + 'deg)';

    setTimeout(function() {
      localStorage.setItem('dds_roulette_spun', 'true');
      stateForm.style.display = 'none';
      stateSuccess.style.display = 'block';
    }, 4000);
  });

  // Copiere cod reducere
  copyBtn.addEventListener('click', function() {
    if (!navigator.clipboard) {
      var ta = document.createElement('textarea');
      ta.value = couponCode;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); copyBtn.innerText = 'Copiat!'; }
      catch (err) { console.error('Copy failed', err); }
      document.body.removeChild(ta);
      return;
    }
    navigator.clipboard.writeText(couponCode).then(function() {
      copyBtn.innerText = 'Copiat!';
      setTimeout(function() { copyBtn.innerText = 'Copiază'; }, 2000);
    });
  });
});
